import { UAPPlacementType } from '../@types';

//
// origanize and alias placement types for easier reference
export const UAPPlacementTypeAlias = {
  MMA: {
    WideImage: UAPPlacementType.MMA_WideImage_4x1,
    LandscapeImage: UAPPlacementType.MMA_LandscapeImage_191x100,
    SquareImage: UAPPlacementType.MMA_SquareImage_1x1,
    VerticalImage: UAPPlacementType.MMA_VerticalImage_1x2,
  },

  MSAN: {
    WideImage: UAPPlacementType.Audience_Network_WideImage_191x100,
    SquareImage: UAPPlacementType.Audience_Network_SquareImage_1x1,
    MSEdgeSingleCarousel: UAPPlacementType.Microsoft_Edge_Single_Carousel_178x100,
    MSNInArticle: UAPPlacementType.MSN_InArticle_Ad_150x100,
    MSNSmallHeadline: UAPPlacementType.MSN_Small_Headline_133x100,
  },

  MSANV2: {
    MSEdgeCarousel: UAPPlacementType.MsanV2_Microsoft_Edge_Carouse_l201x100,
    MSEdgeMobile: UAPPlacementType.MsanV2_Microsoft_Edge_Mobile_1x1,
    MSANBanner: UAPPlacementType.MsanV2_MSAN_Banner_2x1,
    MSANRiver: UAPPlacementType.MsanV2_MSAN_River_191x100,
    MSANRectangle: UAPPlacementType.MsanV2_MSAN_Rectangle_120x100,
    MSANRectangleImage: UAPPlacementType.MsanV2_MSAN_Rectangle_Image_191x100,
    MSNCarousel: UAPPlacementType.MsanV2_MSN_Carousel_169x100,
    MSNPartnerStripe: UAPPlacementType.MsanV2_MSN_Partner_Stripe_153x100,
    MSNRestoday: UAPPlacementType.MsanV2_MSN_Restoday_124x100,
  },

  PMax: {
    AudienceSquareImage: UAPPlacementType.PMax_Audience_Network_SquareImage_1x1,
    AudienceWideImage: UAPPlacementType.PMax_Audience_Network_WideImage_191x100,
    MMALandscapeImage: UAPPlacementType.PMax_MMA_LandscapeImage_191x100,
    MMAVerticalImage: UAPPlacementType.PMax_MMA_VerticalImage_1x2,
    MMAWideImage: UAPPlacementType.PMax_MMA_WideImage_4x1,
    MSNInArticle: UAPPlacementType.PMax_MSN_InArticle_Ad_150x100,
    MSNSmallHeadline: UAPPlacementType.PMax_MSN_Small_Headline_133x100,
    MSEdgeSingleCarousel: UAPPlacementType.PMax_Microsoft_Edge_Single_Carousel_178x100,
    MMAV2MSEdgeCarousel: UAPPlacementType.PMax_MMAV2_Microsoft_Edge_Single_Carousel_201x100,
    MMAV2MSNSingleCarousel: UAPPlacementType.PMax_MMAV2_MSN_Single_Carousel_169x100,
    MMAV2MSNRestoday: UAPPlacementType.PMax_MMAV2_MSN_Restoday_124x100,
    MMAV2MSNPartnerStripe: UAPPlacementType.PMax_MMAV2_MSN_Partner_Stripe_153x100,
    MMAV2MSNRiver: UAPPlacementType.PMax_MMAV2_MSN_River_191x100,
    Video: UAPPlacementType.PMax_Video,
    MSEdgeMobile: UAPPlacementType.PMax_MMAV2_Microsoft_Edge_Mobile_1x1,
  },

  PMaxV2: {
    AudienceSquareImage: UAPPlacementType.PMax_Audience_Network_SquareImage_1x1,
    AudienceWideImage: UAPPlacementType.PMax_Audience_Network_WideImage_191x100,
    MMALandscapeImage: UAPPlacementType.PMax_MMA_LandscapeImage_191x100,
    MMAVerticalImage: UAPPlacementType.PMax_MMA_VerticalImage_1x2,
    MMAWideImage: UAPPlacementType.PMax_MMA_WideImage_4x1,
    MMAV2MSEdgeCarousel: UAPPlacementType.PMax_MMAV2_Microsoft_Edge_Single_Carousel_201x100,
    MMAV2MSNSingleCarousel: UAPPlacementType.PMax_MMAV2_MSN_Single_Carousel_169x100,
    MMAV2MSNRestoday: UAPPlacementType.PMax_MMAV2_MSN_Restoday_124x100,
    MMAV2MSNPartnerStripe: UAPPlacementType.PMax_MMAV2_MSN_Partner_Stripe_153x100,
    MMAV2MSNRiver: UAPPlacementType.PMax_MMAV2_MSN_River_191x100,
    Video: UAPPlacementType.PMax_Video,
    MSEdgeMobile: UAPPlacementType.PMax_MMAV2_Microsoft_Edge_Mobile_1x1,
  },

  Boost: {
    HeroImageCarousel200x100: UAPPlacementType.Boost_Hero_Image_Carousel_200x100,
    HeroImageCarousel122x100: UAPPlacementType.Boost_Hero_Image_Carousel_122x100,
    HeroImageCarousel159x100: UAPPlacementType.Boost_Hero_Image_Carousel_159x100,
    HeroImageCarousel180x100: UAPPlacementType.Boost_Hero_Image_Carousel_180x100,
    HeroImageCarousel233x100: UAPPlacementType.Boost_Hero_Image_Carousel_233x100,
    HeroImageCarousel320x100: UAPPlacementType.Boost_Hero_Image_Carousel_320x100,
    HeroImageCarousel57x100: UAPPlacementType.Boost_Hero_Image_Carousel_57x100,
    WindowsSpotlight: UAPPlacementType.Boost_Windows_Spotlight_191x100,
    DiscoverCard: UAPPlacementType.Boost_Discover_Card_1x1,
    StartMenu: UAPPlacementType.Boost_Start_Menu,
    ActionCenter: UAPPlacementType.Boost_Action_Center,
    Banner: UAPPlacementType.Boost_Banner,
    Prong1Prong2Feed: UAPPlacementType.Boost_Prong1_Prong2_Feed_191x100,
    Coachmark: UAPPlacementType.Boost_Coachmark_175x100,
  },

  ImageExt: {
    MMAV2MSNRiver: UAPPlacementType.ImgExt_MMAV2_MSN_River_191x100,
    MMAV2MSNSingleCarousel: UAPPlacementType.ImgExt_MMAV2_MSN_Single_Carousel_169x100,
    MSEdgeMobile: UAPPlacementType.ImgExt_MMAV2_MSN_Microsoft_Edge_Mobile_1x1,

    WideImage: UAPPlacementType.ImgExt_Audience_Network_WideImage_191x100,
    SquareImage: UAPPlacementType.ImgExt_Audience_Network_SquareImage_1x1,

    MSEdgeMediumHeadline: UAPPlacementType.ImgExt_Microsoft_Edge_Medium_Headline_172x100,
    MSEdgeSingleCarousel: UAPPlacementType.ImgExt_Microsoft_Edge_Single_Carousel_178x100,

    MSNSingleCarousel: UAPPlacementType.ImgExt_MSN_Single_Carousel_169x100,
    MSNMediumHeadline: UAPPlacementType.ImgExt_MSN_Medium_Headline_155x100,
    MSNInArticle: UAPPlacementType.ImgExt_MSN_InArticle_Ad_150x100,
    MSNSmallHeadline: UAPPlacementType.ImgExt_MSN_Small_Headline_133x100,
    MSNDoubleCarousel: UAPPlacementType.ImgExt_MSN_Double_Carousel_93x100,

    BingDesktopSingleImage: UAPPlacementType.ImgExt_Bing_Desktop_SingleImage_Extension_178x100,
    BingDesktopMultiImage: UAPPlacementType.ImgExt_Bing_Desktop_MultiImage_Extension_133x100,
    BingMobileMultiImage: UAPPlacementType.ImgExt_Bing_Mobile_MultiImage_Extension_133x100,
  },

  Outlook: {
    Mobile: UAPPlacementType.Outlook_Text_Mobile,
    Web: UAPPlacementType.Outlook_Text_Web,
  },

  BingSearch: {
    Mobile: UAPPlacementType.Bing_Search_Mobile,
    Desktop: UAPPlacementType.Bing_Search_Desktop,
    Text: UAPPlacementType.Bing_Search_Text,
  },

  Responsive: {
    MMA: {
      WideImage: UAPPlacementType.Responsive_MMA_WideImage_4x1,
      LandscapeImage: UAPPlacementType.Responsive_MMA_LandscapeImage_191x100,
      SquareImage: UAPPlacementType.Responsive_MMA_SquareImage_1x1,
      VerticalImage: UAPPlacementType.Responsive_MMA_VerticalImage_1x2,
    },

    MSAN: {
      WideImage: UAPPlacementType.Responsive_Audience_Network_WideImage_191x100,
      SquareImage: UAPPlacementType.Responsive_Audience_Network_SquareImage_1x1,
      MSEdgeSingleCarousel: UAPPlacementType.Responsive_Microsoft_Edge_Single_Carousel_178x100,
      MSNInArticle: UAPPlacementType.Responsive_MSN_InArticle_Ad_150x100,
      MSNSmallHeadline: UAPPlacementType.Responsive_MSN_Small_Headline_133x100,
    },

    MSANV2: {
      MSEdgeCarousel: UAPPlacementType.Responsive_MsanV2_Microsoft_Edge_Carouse_l201x100,
      MSEdgeMobile: UAPPlacementType.Responsive_MsanV2_Microsoft_Edge_Mobile_1x1,
      MSANBanner: UAPPlacementType.Responsive_MsanV2_MSAN_Banner_2x1,
      MSANRiver: UAPPlacementType.Responsive_MsanV2_MSAN_River_191x100,
      MSANRectangle: UAPPlacementType.Responsive_MsanV2_MSAN_Rectangle_120x100,
      MSANRectangleImage: UAPPlacementType.MsanV2_MSAN_Rectangle_Image_191x100,
      MSNCarousel: UAPPlacementType.Responsive_MsanV2_MSN_Carousel_169x100,
      MSNPartnerStripe: UAPPlacementType.Responsive_MsanV2_MSN_Partner_Stripe_153x100,
      MSNRestoday: UAPPlacementType.Responsive_MsanV2_MSN_Restoday_124x100,
    },

    Outlook: {
      Mobile: UAPPlacementType.Responsive_Outlook_Text_Mobile,
      Web: UAPPlacementType.Responsive_Outlook_Text_Web,
    },

    BingSearch: {
      Text: UAPPlacementType.Responsive_Bing_Search_Text,
    },

    Boost: {
      WindowsSpotlight: UAPPlacementType.Responsive_Boost_Windows_Spotlight_191x100,
      DiscoverCard: UAPPlacementType.Responsive_Boost_Discover_Card_1x1,
      StartMenu: UAPPlacementType.Responsive_Boost_Start_Menu,
      ActionCenter: UAPPlacementType.Responsive_Boost_Action_Center,
      Banner: UAPPlacementType.Responsive_Boost_Banner,
      Prong1Prong2Feed: UAPPlacementType.Responsive_Boost_Prong1_Prong2_Feed_191x100,
      Coachmark: UAPPlacementType.Responsive_Boost_Coachmark_175x100,
      MiniSpotlight: UAPPlacementType.Responsive_Boost_Mini_Spotlight,
      SpotlightPortrait: UAPPlacementType.Responsive_Boost_Spotlight_Portrait,
      ContentHub: UAPPlacementType.Responsive_Boost_Content_Hub,
      MicrosoftPlus: UAPPlacementType.Responsive_Boost_Microsoft_Plus,
    },

    PMax: {
      AudienceSquareImage: UAPPlacementType.Responsive_PMax_Audience_Network_SquareImage_1x1,
      AudienceWideImage: UAPPlacementType.Responsive_PMax_Audience_Network_WideImage_191x100,
      MMALandscapeImage: UAPPlacementType.Responsive_PMax_MMA_LandscapeImage_191x100,
      MMAVerticalImage: UAPPlacementType.Responsive_PMax_MMA_VerticalImage_1x2,
      MMAWideImage: UAPPlacementType.Responsive_PMax_MMA_WideImage_4x1,
      MSNInArticle: UAPPlacementType.Responsive_PMax_MSN_InArticle_Ad_150x100,
      MSNSmallHeadline: UAPPlacementType.Responsive_PMax_MSN_Small_Headline_133x100,
      MSEdgeSingleCarousel: UAPPlacementType.Responsive_PMax_Microsoft_Edge_Single_Carousel_178x100,
      MMAV2MSEdgeCarousel: UAPPlacementType.Responsive_PMax_MMAV2_Microsoft_Edge_Single_Carousel_201x100,
      MMAV2MSNSingleCarousel: UAPPlacementType.Responsive_PMax_MMAV2_MSN_Single_Carousel_169x100,
      MMAV2MSNRestoday: UAPPlacementType.Responsive_PMax_MMAV2_MSN_Restoday_124x100,
      MMAV2MSNPartnerStripe: UAPPlacementType.Responsive_PMax_MMAV2_MSN_Partner_Stripe_153x100,
      MMAV2MSNRiver: UAPPlacementType.Responsive_PMax_MMAV2_MSN_River_191x100,
      MSEdgeMobile: UAPPlacementType.Responsive_PMax_MMAV2_Microsoft_Edge_Mobile_1x1,
    },

    PMaxV2: {
      AudienceSquareImage: UAPPlacementType.PMax_Audience_Network_SquareImage_1x1,
      AudienceWideImage: UAPPlacementType.PMax_Audience_Network_WideImage_191x100,
      MMALandscapeImage: UAPPlacementType.PMax_MMA_LandscapeImage_191x100,
      MMAVerticalImage: UAPPlacementType.PMax_MMA_VerticalImage_1x2,
      MMAWideImage: UAPPlacementType.PMax_MMA_WideImage_4x1,
      MMAV2MSEdgeCarousel: UAPPlacementType.PMax_MMAV2_Microsoft_Edge_Single_Carousel_201x100,
      MMAV2MSNSingleCarousel: UAPPlacementType.PMax_MMAV2_MSN_Single_Carousel_169x100,
      MMAV2MSNRestoday: UAPPlacementType.PMax_MMAV2_MSN_Restoday_124x100,
      MMAV2MSNPartnerStripe: UAPPlacementType.PMax_MMAV2_MSN_Partner_Stripe_153x100,
      MMAV2MSNRiver: UAPPlacementType.PMax_MMAV2_MSN_River_191x100,
      MSEdgeMobile: UAPPlacementType.PMax_MMAV2_Microsoft_Edge_Mobile_1x1,
    },
  },

  ResponsiveSearch: {
    Text: UAPPlacementType.Responsive_Search,
    Desktop: UAPPlacementType.Responsive_Search_Desktop,
    Mobile: UAPPlacementType.Responsive_Search_Mobile,
  },

  DynamicSearch: {
    Dynamic: UAPPlacementType.Dynamic_Search,
  },

  LinkedIn: {
    Landscape: {
      SingleImageDesktop: UAPPlacementType.LinkedIn_Single_Image_Desktop_Landscape,
      SingleImageMobile: UAPPlacementType.LinkedIn_Single_Image_Mobile_Landscape,
    },
    Square: {
      SingleImageDesktop: UAPPlacementType.LinkedIn_Single_Image_Desktop_Square,
      SingleImageMobile: UAPPlacementType.LinkedIn_Single_Image_Mobile_Square,
    },
    Vertical: {
      SingleImageMobile: UAPPlacementType.LinkedIn_Single_Image_Mobile_Vertical,
    },
  },

  UnifiedAppAds: {
    VideoHorizontal: UAPPlacementType.Unified_App_Ads_Video_Horizontal,
    M365Outlook: UAPPlacementType.Unified_App_Ads_M365_Outlook,
    MSNDisplay: UAPPlacementType.Unified_App_Ads_MSN_Display,
    CasualGamesDimensions: UAPPlacementType.Unified_App_Ads_Causal_Games_Dimensions,
    BingSearch: UAPPlacementType.Unified_App_Ads_Bing_Search,
    BingSearchText: UAPPlacementType.Unified_App_Ads_Bing_Search_Text,
  },
};

UAPPlacementTypeAlias.MMA.All = [
  UAPPlacementType.MMA_WideImage_4x1,
  UAPPlacementType.MMA_LandscapeImage_191x100,
  UAPPlacementType.MMA_SquareImage_1x1,
  UAPPlacementType.MMA_VerticalImage_1x2,
];

UAPPlacementTypeAlias.MSAN.All = [
  UAPPlacementType.Audience_Network_WideImage_191x100,
  UAPPlacementType.Microsoft_Edge_Single_Carousel_178x100,
  UAPPlacementType.MSN_InArticle_Ad_150x100,
  UAPPlacementType.MSN_Small_Headline_133x100,
  UAPPlacementType.Audience_Network_SquareImage_1x1,
];

UAPPlacementTypeAlias.MSANV2.All = [
  UAPPlacementType.MsanV2_Microsoft_Edge_Carouse_l201x100,
  UAPPlacementType.MsanV2_MSAN_Banner_2x1,
  UAPPlacementType.MsanV2_MSAN_River_191x100,
  UAPPlacementType.MsanV2_MSN_Carousel_169x100,
  UAPPlacementType.MsanV2_MSN_Partner_Stripe_153x100,
  UAPPlacementType.MsanV2_MSN_Restoday_124x100,
  UAPPlacementType.MsanV2_MSAN_Rectangle_120x100,
  UAPPlacementType.MsanV2_Microsoft_Edge_Mobile_1x1,
];

UAPPlacementTypeAlias.PMax.All = [
  UAPPlacementType.PMax_MMA_WideImage_4x1,
  UAPPlacementType.PMax_Audience_Network_WideImage_191x100,
  UAPPlacementType.PMax_MMA_LandscapeImage_191x100,
  UAPPlacementType.PMax_Microsoft_Edge_Single_Carousel_178x100,
  UAPPlacementType.PMax_MSN_InArticle_Ad_150x100,
  UAPPlacementType.PMax_MSN_Small_Headline_133x100,
  UAPPlacementType.PMax_Audience_Network_SquareImage_1x1,
  UAPPlacementType.PMax_MMA_VerticalImage_1x2,
];

UAPPlacementTypeAlias.PMaxV2.All = [
  UAPPlacementType.PMax_MMA_WideImage_4x1,
  UAPPlacementType.PMax_Audience_Network_WideImage_191x100,
  UAPPlacementType.PMax_MMA_LandscapeImage_191x100,
  UAPPlacementType.PMax_Audience_Network_SquareImage_1x1,
  UAPPlacementType.PMax_MMA_VerticalImage_1x2,
  UAPPlacementType.PMax_MMAV2_Microsoft_Edge_Single_Carousel_201x100,
  UAPPlacementType.PMax_MMAV2_MSN_Single_Carousel_169x100,
  UAPPlacementType.PMax_MMAV2_MSN_Partner_Stripe_153x100,
  UAPPlacementType.PMax_MMAV2_MSN_Restoday_124x100,
];

UAPPlacementTypeAlias.PMaxV2.AllV2 = [
  UAPPlacementType.PMax_MMA_WideImage_4x1,
  UAPPlacementType.PMax_MMA_LandscapeImage_191x100,
  UAPPlacementType.PMax_MMAV2_Microsoft_Edge_Mobile_1x1,
  UAPPlacementType.PMax_MMA_VerticalImage_1x2,
  UAPPlacementType.PMax_MMAV2_Microsoft_Edge_Single_Carousel_201x100,
  UAPPlacementType.PMax_MMAV2_MSN_Single_Carousel_169x100,
  UAPPlacementType.PMax_MMAV2_MSN_Partner_Stripe_153x100,
  UAPPlacementType.PMax_MMAV2_MSN_Restoday_124x100,
  UAPPlacementType.PMax_MMAV2_MSN_River_191x100,
];

UAPPlacementTypeAlias.ImageExt.All = [
  UAPPlacementType.ImgExt_Audience_Network_WideImage_191x100,
  UAPPlacementType.ImgExt_Microsoft_Edge_Single_Carousel_178x100,
  UAPPlacementType.ImgExt_Bing_Desktop_SingleImage_Extension_178x100,
  UAPPlacementType.ImgExt_Microsoft_Edge_Medium_Headline_172x100,
  UAPPlacementType.ImgExt_MSN_Single_Carousel_169x100,
  UAPPlacementType.ImgExt_MSN_Medium_Headline_155x100,
  UAPPlacementType.ImgExt_MSN_InArticle_Ad_150x100,
  UAPPlacementType.ImgExt_MSN_Small_Headline_133x100,
  UAPPlacementType.ImgExt_Bing_Desktop_MultiImage_Extension_133x100,
  UAPPlacementType.ImgExt_Bing_Mobile_MultiImage_Extension_133x100,
  UAPPlacementType.ImgExt_Audience_Network_SquareImage_1x1,
  UAPPlacementType.ImgExt_MSN_Double_Carousel_93x100,
];

UAPPlacementTypeAlias.ImageExt.AllV2 = [
  UAPPlacementType.ImgExt_MMAV2_MSN_River_191x100,
  UAPPlacementType.ImgExt_Bing_Desktop_SingleImage_Extension_178x100,
  UAPPlacementType.ImgExt_Microsoft_Edge_Medium_Headline_172x100,
  UAPPlacementType.ImgExt_MMAV2_MSN_Single_Carousel_169x100,
  UAPPlacementType.ImgExt_Bing_Desktop_MultiImage_Extension_133x100,
  UAPPlacementType.ImgExt_Bing_Mobile_MultiImage_Extension_133x100,
  UAPPlacementType.ImgExt_MMAV2_MSN_Microsoft_Edge_Mobile_1x1,
  UAPPlacementType.ImgExt_Microsoft_Edge_Single_Carousel_178x100,
  UAPPlacementType.ImgExt_MSN_Medium_Headline_155x100,
  UAPPlacementType.ImgExt_MSN_InArticle_Ad_150x100,
  UAPPlacementType.ImgExt_MSN_Small_Headline_133x100,
  UAPPlacementType.ImgExt_MSN_Double_Carousel_93x100,
];

UAPPlacementTypeAlias.BingSearch.All = [
  UAPPlacementType.Bing_Search_Text,
  UAPPlacementType.Bing_Search_Desktop,
  UAPPlacementType.Bing_Search_Mobile,
];

UAPPlacementTypeAlias.Boost.All = [
  UAPPlacementType.Boost_Hero_Image_Carousel_200x100,
  UAPPlacementType.Boost_Hero_Image_Carousel_122x100,
  UAPPlacementType.Boost_Hero_Image_Carousel_159x100,
  UAPPlacementType.Boost_Hero_Image_Carousel_180x100,
  UAPPlacementType.Boost_Hero_Image_Carousel_233x100,
  UAPPlacementType.Boost_Hero_Image_Carousel_320x100,
  UAPPlacementType.Boost_Hero_Image_Carousel_57x100,
  UAPPlacementType.Boost_Windows_Spotlight_191x100,
  UAPPlacementType.Boost_Discover_Card_1x1,
  UAPPlacementType.Boost_Start_Menu,
  UAPPlacementType.Boost_Action_Center,
  UAPPlacementType.Boost_Banner,
  UAPPlacementType.Boost_Prong1_Prong2_Feed_191x100,
  UAPPlacementType.Boost_Coachmark_175x100,
];

UAPPlacementTypeAlias.ResponsiveSearch.All = [
  UAPPlacementType.Responsive_Search,
  UAPPlacementType.Responsive_Search_Desktop,
  UAPPlacementType.Responsive_Search_Mobile,
];

UAPPlacementTypeAlias.DynamicSearch.All = [
  UAPPlacementType.Dynamic_Search,
];

UAPPlacementTypeAlias.LinkedIn.All = [
  UAPPlacementType.LinkedIn_Single_Image_Desktop_Landscape,
  UAPPlacementType.LinkedIn_Single_Image_Mobile_Landscape,

  UAPPlacementType.LinkedIn_Single_Image_Desktop_Square,
  UAPPlacementType.LinkedIn_Single_Image_Mobile_Square,

  UAPPlacementType.LinkedIn_Single_Image_Mobile_Vertical,
];

